"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CategoryOfProductField = void 0;

var _core = require("@material-ui/core");

var _react = _interopRequireWildcard(require("react"));

var _formValidators = require("react-platform-components/dist/form-validators");

var _reactRedux = require("react-redux");

var _CategoryOfProductPopup = require("./CategoryOfProductPopup");

var _formFields = require("react-platform-components/dist/form-fields");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var CategoryOfProductField = function CategoryOfProductField(props) {
  var _useSelector = (0, _reactRedux.useSelector)(function (_ref) {
    var categoryOfProductReducer = _ref.categoryOfProductReducer;
    return {
      categories: categoryOfProductReducer.categories,
      fetchCategoriesInProgress: categoryOfProductReducer.fetchCategoriesInProgress,
      isFetchingSubCategoriesInProgress: categoryOfProductReducer.isFetchingSubCategoriesInProgress,
      isFetchingAdditionalCategoriesInProgress: categoryOfProductReducer.isFetchingAdditionalCategoriesInProgress
    };
  }),
      categories = _useSelector.categories,
      fetchCategoriesInProgress = _useSelector.fetchCategoriesInProgress,
      isFetchingSubCategoriesInProgress = _useSelector.isFetchingSubCategoriesInProgress,
      isFetchingAdditionalCategoriesInProgress = _useSelector.isFetchingAdditionalCategoriesInProgress;

  var getMainCategories = function getMainCategories(categories) {
    var parents = categories.filter(function (category) {
      return !category.is_final && !category.parent_category_id || category.is_final && !category.parent_category_id;
    });
    return parents;
  }; // main categories they are don't have a parent_category


  var mainCategories = (0, _react.useMemo)(function () {
    return categories.length > 0 ? getMainCategories(categories) : [];
  }, [JSON.stringify(categories)]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12,
    id: "category_filter"
  }, /*#__PURE__*/_react.default.createElement(_formFields.Select, _extends({
    variant: "outlined",
    fullWidth: true,
    required: true,
    label: "Category",
    name: "category",
    validate: props.required ? (0, _formValidators.required)() : null,
    renderValue: function renderValue() {
      var _$find;

      return (_$find = _.find(categories, function (category) {
        return Number(category.id) === Number(props.values.category);
      })) === null || _$find === void 0 ? void 0 : _$find.name;
    }
  }, fetchCategoriesInProgress ? {
    endAdornment: /*#__PURE__*/_react.default.createElement(_core.InputAdornment, {
      position: "start",
      style: {
        marginRight: 20
      }
    }, /*#__PURE__*/_react.default.createElement(_core.CircularProgress, {
      size: 24
    }))
  } : null), !fetchCategoriesInProgress && /*#__PURE__*/_react.default.createElement(_CategoryOfProductPopup.CategoryOfProductPopup, _extends({}, props, {
    mainCategories: mainCategories,
    categories: categories,
    inProgress: isFetchingSubCategoriesInProgress || isFetchingAdditionalCategoriesInProgress
  })))));
};

exports.CategoryOfProductField = CategoryOfProductField;